module.exports = __webpack_public_path__ + "0e2baf301e8a7ce251edd93df3c734ea.svg";